export const common = {
  // Header Navigation
  nav: {
    home: 'HOME',
    brandStory: 'BRAND STORY',
    whoWeServe: 'WHO WE SERVE',
    products: 'PRODUCTS',
    elite: 'ELITE',
    privateLabel: 'PRIVATE LABEL',
    shop: 'SHOP',
    contact: 'CONTACT',
  },
  
  // Product Categories
  productCategories: {
    // Coffee submenu
    coffee: 'Coffee',
    roastedCoffee: 'Roasted Coffee',
    pods: 'Pods',
    compatibleCapsules: 'Compatible Capsules',
    // HoReCa submenu
    horeca: 'Additional HoReCa Solutions',
    milkshakes: 'Milkshakes',
    coldGlaze: 'Cold Glaze',
    toppingSauce: 'Topping Sauce',
    coffeeBarSauce: 'Coffee Bar Sauce',
    fillingSauce: 'Filling Sauce',
    fillingFruit: 'Filling Fruit',
    praline: 'Praline',
    refresher: 'Refresher',
    // Other
    chocolate: 'Chocolate',
    machines: 'Coffee & Tea Machines',
    // Elite submenu
    eliteCoffee: 'Coffee',
    eliteMilkshake: 'Milkshake',
    eliteTea: 'Tea',
    eliteChocolate: 'Chocolate',
    colombian: 'Colombian',
    ethiopian: 'Ethiopian',
    luxury: 'Luxury Elite',
    eliteRoastedBeans: 'Roasted Beans',
    elitePods: 'Pods',
  },
  
  // Common Actions
  actions: {
    seeDetails: 'See Details',
    learnMore: 'Learn More',
    contactUs: 'Contact Us',
    viewAll: 'View All',
  },
  
  // Footer
  footer: {
    tagline: 'Where vision becomes form',
    description: 'Premium coffee and HoReCa solutions crafted for excellence. Rooted in Italian heritage, engineered for global hospitality.',
    companyInfo: 'MİACCENDO GIDA SANAYİ VE TİCARET LİMİTED ŞİRKETİ',
    address: 'ADDRESS',
    email: 'EMAIL',
    copyright: '© 2026 LUCENDO. All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms',
    poweredBy: 'Powered by Akıllı Mum',
  },
};
